import { useRecoilValue } from 'recoil';
import { organizationConfigAtom } from 'services/organization/atom';

/**
 * @description Hook to get organizationConfig from the Recoil store
 * @returns organizationConfig
 */
export const useOrganizationConfig = () => {
  const organizationConfig = useRecoilValue(organizationConfigAtom);

  return organizationConfig;
};
